import ChangeRequests from './ChangeRequests';

export default ChangeRequests;
